import React from "react";
import ReportCard from "./components/ReportCard";
import { PAYMENT_REPORT_VIEWERS, REPORT_VIEWERS } from "../../constants/roles";
import { useCurrentUser } from "../../utilities/currentUser";
import { userHasAnyRole } from "../../utils/leadershipRoles";

// Each card lists who may open the report (mirrors the report routes in backend/routes/api.php).
// Only the two payment reports are open to the Finance Director.
export const REPORT_CARDS = [
  {
    title: "Sold Unit Report",
    description: "Flat / Plot / Unit sold summary",
    link: "/reports/sold-units",
    roles: REPORT_VIEWERS,
  },
  {
    title: "Sales By Role (MO/MM)",
    description: "Sold units grouped by marketing role",
    link: "/reports/sales-by-role",
    roles: REPORT_VIEWERS,
  },
  {
    title: "Pending Payment Report",
    description: "Pending installments by booking/unit",
    link: "/reports/pending-payments",
    roles: PAYMENT_REPORT_VIEWERS,
  },
  {
    title: "Overdue Payments",
    description: "Late installments (due date + grace)",
    link: "/reports/overdue-payments",
    roles: PAYMENT_REPORT_VIEWERS,
  },
  {
    title: "Sold By Agent Report",
    description: "Sold By Agent Report",
    link: "/reports/agent-wise",
    roles: REPORT_VIEWERS,
  },
  {
    title: "Sold By Date/Month Report",
    description: "Sold By Date/Month Report",
    link: "/reports/sold-units-month-wise",
    roles: REPORT_VIEWERS,
  },
  {
    title: "Property Wise Report",
    description: "Property Wise Report",
    link: "/reports/property-wise",
    roles: REPORT_VIEWERS,
  },
  {
    title: "Top Selling Report",
    description: "Most popular properties by sold count & revenue",
    link: "/reports/top-selling-properties",
    roles: REPORT_VIEWERS,
  },
  {
    title: "Inventory Report",
    description: "Available vs booked vs other statuses",
    link: "/reports/inventory",
    roles: REPORT_VIEWERS,
  },
  {
    title: "Price Trends",
    description: "Price per sqft over time (sale & rent)",
    link: "/reports/price-trends",
    roles: REPORT_VIEWERS,
  },
  {
    title: "Time to Sell",
    description: "Average days from listing to sale by unit type",
    link: "/reports/time-to-sell",
    roles: REPORT_VIEWERS,
  },
];

const ReportsDashboard = () => {
  const { user } = useCurrentUser();
  const cards = REPORT_CARDS.filter((card) => userHasAnyRole(user, card.roles));

  return (
    <div className="container py-4">
      <h3 className="mb-4 fw-bold">Report Dashboard</h3>

      <div className="row g-4">
        {cards.map((card) => (
          <div className="col-md-4" key={card.link}>
            <ReportCard
              title={card.title}
              description={card.description}
              link={card.link}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsDashboard;
